import React, { useState } from 'react';

function FAQ() {
  return (
    <>
      <section className="inner-intro bg-1 bg-overlay-black-70">
        <div className="container">
          <div className="row text-center intro-title">
            <div className="col-md-12 text-md-start d-inline-block">
              <div className="section-title">
                <h2 className="text-center" style={{color: 'white'}}>Frequently Asked Questions</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy-policy page-section-ptb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <span>Have a question? Please check our knowledgebase first.</span>
                <h2>Frequently Asked Questions</h2>
                <div className="separator"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div id="tabs">
                <div className="tabs-header d-flex justify-content-center">
                  <ul className="nav nav-tabs justify-content-center" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="general-information-tab" data-bs-toggle="tab" data-bs-target="#general-information" type="button" role="tab" aria-controls="general-information" aria-selected="true">
                        General Information
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="features-options-tab" data-bs-toggle="tab" data-bs-target="#features-options" type="button" role="tab" aria-controls="features-options" aria-selected="false">
                        Features & Options
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="vehicle-overview-tab" data-bs-toggle="tab" data-bs-target="#vehicle-overview" type="button" role="tab" aria-controls="vehicle-overview" aria-selected="false">
                        Vehicle Overview
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab-content mb-0" id="myTabContent">
                  <div className="tab-pane fade show active" id="general-information" role="tabpanel" aria-labelledby="general-information-tab">
                    <div className="accordion" id="accordionExample01">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            What is the valet parking process?
                          </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample01">
                          <div className="accordion-body">
                            <h6>Simple and Efficient Process</h6>
                            <p>Our valet parking service follows a streamlined process. When you arrive, our professionally trained valet will greet you and provide a ticket with a unique QR code. Your vehicle is then parked securely in our designated parking area. When you're ready to leave, simply present your ticket, and we'll retrieve your vehicle promptly.</p>
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            How do I request my car back?
                          </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample01">
                          <div className="accordion-body">
                            <h6>Quick and Easy Retrieval</h6>
                            <p>Requesting your car is simple. Present your valet ticket to our staff or use our mobile app to submit a retrieval request. We recommend giving us a 10-15 minute notice for the smoothest experience, especially during peak hours.</p>
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            What happens if I lose my valet ticket?
                          </button>
                        </h2>
                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample01">
                          <div className="accordion-body">
                            <h6>Security Verification Process</h6>
                            <p>If you lose your valet ticket, don't worry. We have a verification process in place. You'll need to present a valid ID and proof of ownership (vehicle registration or insurance). Additional verification may be required for your security.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tab-pane fade" id="features-options" role="tabpanel" aria-labelledby="features-options-tab">
                    <div className="accordion" id="accordionExample02">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingFour">
                          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                            What special services do you offer?
                          </button>
                        </h2>
                        <div id="collapseFour" className="accordion-collapse collapse show" aria-labelledby="headingFour" data-bs-parent="#accordionExample02">
                          <div className="accordion-body">
                            <h6>Premium Services Available</h6>
                            <p>We offer several premium services including VIP parking, event parking management, and corporate parking solutions. Our team can accommodate special requests and provide customized services based on your needs.</p>
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingFive">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                            Do you offer insurance coverage?
                          </button>
                        </h2>
                        <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample02">
                          <div className="accordion-body">
                            <h6>Comprehensive Coverage</h6>
                            <p>Yes, we maintain comprehensive insurance coverage for all vehicles in our care. Our policy covers potential damages while your vehicle is under our supervision, giving you complete peace of mind.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tab-pane fade" id="vehicle-overview" role="tabpanel" aria-labelledby="vehicle-overview-tab">
                    <div className="accordion" id="accordionExample03">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingSix">
                          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                            What types of vehicles do you handle?
                          </button>
                        </h2>
                        <div id="collapseSix" className="accordion-collapse collapse show" aria-labelledby="headingSix" data-bs-parent="#accordionExample03">
                          <div className="accordion-body">
                            <h6>All Vehicle Types Welcome</h6>
                            <p>We handle all types of vehicles, from standard cars to luxury vehicles, SUVs, and sports cars. Our valets are trained to operate various vehicle types and models with the utmost care and professionalism.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FAQ;
